const locale = {
	TIMELITE: "TimeLite",
	REPORT: "Report",
	REPORTS: 'Reports',
	TOTAL: "Total",
	PERIOD: "Period",
	YEAR: "Year",
	MONTH: "Month",
	INDIVIDUALLY: "Individually",
	FROM: "from",
	TO: "to",
	SAVE: "Save",
	CANCEL: "Cancel",
	ABSENCEREPLACEMENT: "Absence replacement",
	ABSENCEREPLACEMENTASSIGNMENTS: "Replacement assignments",
	NEWABSENCEREPLACEMENT: "New replacement",
	EDITABSENCEREPLACEMENT: "Edit replacement",
	MYABSENCEREPLACEMENTS: "My absence replacements",
	NOABSENCEREPLACEMENTSINRANGE: "You have not defined any absence replacements in this period.",
	NOABSENCEREPLACEMENTASSIGNMENTSINRANGE: "You have not received any replacement assignments in this period.",
	REPLACEMENTUSER: "Replacement user",
	CURRENTREPLACEMENT: "Current replacement",
	ASSIGNEDASREPLACEMENT: "Replacement for",
	DELETEABSENCEREPLACEMENT: "Delete absence replacement",
	DELETEABSENCEREPLACEMENTQUESTION: "Do you want to delete this absence replacement?",
	CHANGE: "Change",
	EXPORT: "Export",
	OBSERVATIONPERIODCHANGE: "Change Observation period",
	OBSERVATIONPERIOD: "Observation period",
	CHOOSEOBSERVATIONPERIOD: "Choose Observation period",
	SELECTDATERANGE: "Select date range",
	SELECTDATE: "Select date",
	PLEASESELECTDATERANGE: "Please select a date range first",
	TOTALBALANCE: "Working balance",
	CURRENTTOTALBALANCE: "Current working balance",
	UNTILLASTMONTHTOTALBALANCE: "Working balance until end of last month",
	UNTILLASTWEEKTOTALBALANCE: "Working balance until end of last week",
	ACTUALHOURS: "Actual work",
	SHOULDHOURS: "Should work",
	ACTUAL: "Actual",
	SHOULD: "Should",
	VACATIONDAYSBALANCE: "Vacation balance",
	CURRENTVACATIONDAYSBALANCE: "Current vacation balance",
	UNTILLASTMONTHVACATIONDAYSBALANCE: "Vacation balance until end of last month",
	UNTILLASTWEEKVACATIONDAYSBALANCE: "Vacation balance until end of last week",
	AVAILABLE: "Available",
	USED: "Used",
	NEWAVAILABLE: "New available",
	NEWUSED: "New used",
	DETAILVIEW: "Detail view",
	ACTIVITYERRORS: "Activity errors",
	MYACTIVITYERRORS: "Your activity errors",
	OTHERACTIVITYERRORS: "Activity errors of assigned employees",
	ROWSPERPAGE: "Rows per page",
	OF: "of",
	DATE: "Date",
	TIME: "Time",
	ACTIVITIES: "Activities",
	ERRORINFO: "Error info",
	ERROR: "Error",
	ERRORS: "Errors",
	BALANCE: "Balance",
	HIDEDAYSWITHOUTACTIVITIES: "Hide days without activities",
	DAYDETAILS: "Days details of",
	ACTIVITYTYPE: "Activitytype",
	OBJECT: "Object",
	OBJECTS: "Objects",
	CUSTOMER: "Customer",
	ACTIVITYDESCRIPTION: "Activity description",
	DURATION: "Duration",
	ALL: "All",
	EXPORTSELECTEDDATA: "Export selected data",
	EXPORTAS: "Export as",
	EXPORTTYPE: "Export type",
	WITHSIGNATURE: "with signature field",
	SHOWCALCULATIONTIMESTAMP: "Show calculation timestamp",
	SHOWSEALEDREPORT: "Show sealed on report",
	WITHGRAPHS: "with graphical details",
	DAYTOTALOVERVIEW: "Day total overviews",
	OBJECTTOTALOVERVIEW: "{{object}} total overviews",
	HYBRIDVIEW: "Hybrid view",
	SINGLELISTINGS: "Single listings",
	INCLUDEPREBALANCE: "Include pre-balance",
	INCLUDEFUTUREPLANNED: "Include future planned",
	PEOPLE: "People",
	SUBORDINATEEMPLOYEES: "Assigned employees",
	SELECTEDEMPLOYEE: "Selected employee",
	BACK: "Back",
	NAME: "Name",
	USERNAME: "Username",
	EMAIL: "Email",
	PHONE: "Phone",
	NODATAFOUND: "No data available",
	DAY: "Day",
	DAYS: "Days",
	CHARGED: "Charged",
	DEDUCTION: "deduction",
	CREDIT: "credit",
	MANUALCOMPENSATION: "Manual balance compensation",
	MANUALCOMPENSATIONS: "Manual balance compensations",
	AUTOMATICCOMPENSATION: "Automatic balance compensation",
	TOOBJECT: "to {{object}}",
	TOOBJECTSHORT: "to",
	WITHREASON: "with reason",
	WITHNOREASON: "with no reason",
	BECAUSEOFTHEOVERTIMEFLATRATE: "overtime flatrate",
	REPORTFOR: "Report for",
	CALCULATEDDATE: "Calculation time",
	SIGNATURESUPERVISOR: "Signature employer",
	SIGNATUREEMPLOYEE: "Signature employee",
	SIGNATUREINFOTEXT: "Employees and employers declare that the data recorded reflect the actually worked and that the records have been checked and found to be correct.",
	ACCEPTANCE: "Acceptance",
	TOTALBALANCETRANSFERFROMBEFORE: "Work carried over before",
	VACATIONDAYSBALANCETRANSFERFROMBEFORE: "Vacation carryover before",
	OBSERVATIONWITHOUTBALANCEBEFORE: "Pure observation period without taking into account the balances from before. ",
	CALCULATIONDATE: "Calculation date",
	TYPE: "Type",
	WORKDAY: "Workday",
	DAYFREE: "Day off",
	HOLIDAY: "Holiday",
	VACATION: "Vacation",
	SICKLEAVE: "Sick leave",
	MIXED: "Mixed",
	INFO: "Info",
	NOACTIVITIESONTHATDAY: "No activities on that day available.",
	LINKNOTVALIDFORUSER: "This link is not valid for your user",
	OVERVIEW: "Overview",
	WELCOMEBACK: "Welcome back",
	NOCURRENTTIMELITENOTIFICATIONS: "You currently have no TimeLine notifications",
	WEEK: "Week",
	CURRENTTIMEACCOUNT: "Live view",
	HOURBALANCETODAY: "Balance today",
	QUICKSWITCH: "Quickswitch",
	ENDMODE: "End mode",
	ENDMODEEARLY: "End mode early",
	CANCELMODE: "Cancel mode",
	CLOSEMODE: "Close mode",
	ONOBJECT: "on {{object}}",
	ONOBJECTSHORT: "on",
	WITHOBJECT: "with {{object}}",
	WITHOBJECTSHORT: "with",
	SINCE: "since",
	UNTIL: "until",
	TIMEPRE: "",
	TIMEPOST: "",
	ACTIVITYISNOTAPPROVED: "Activity is not yet approved",
	ACTIVITYHASHIGHERREVISION: "Activity has already changes pending",
	STARTAT: "Start at",
	START: "Start",
	ENDAT: "End at",
	END: "End",
	STARTNOW: "Instant start",
	ENDNOW: "Instant end",
	BACKWARDS: "Backwards",
	OWNTIME: "Custom time",
	CLOCKINNOW: "Clock in now",
	CHOOSEAWORKMODE: "Choose a workmode",
	WORKMODE: "Workmode",
	WORKDESCRIPTION: "Work description",
	ACTIVITYDESCRIPTION_SUGGESTIONS: "Activity Description Suggestions",
	ACTIVITYDESCRIPTION_SUGGESTIONS_HELP: "Number of suggestions to show (0 = off)",
	OBJECTINFORMATION: "{{object}} informationen",
	DESCRIPTION: "Description",
	ON: "on",
	FULLDAY: "fullday",
	HALFDAY: "halfday",
	HALFDAYFIRST: "first half",
	HALFDAYSECOND: "second half",
	YESTERDAY: "yesterday",
	TOMORROW: "tomorrow",
	NOACTIVITYACTIVE: "No activity active",
	ENDED: "finished",
	BEGINS: "begins",
	AT: "at",
	NOWORKMODEASSIGNED: "No workmode assigned",
	OBJECTSASSIGNMENT: "{{objects}} assignment",
	NOOBJECTASSIGNMENT: "Without {{objects}} assignment",
	FROMTODAYTO: "from today until incl.",
	TODAY: "Today",
	ALONGERPERIOD: "A longer period",
	CALENDAR: "Calendar",
	ADD: "Add",
	LISTVIEW: "Listview",
	MYCALENDAR: "My calendar",
	EMPLOYEECALENDAR: "Employee calendar",
	VACATIONCALENDAR: "Vacation calendar",
	MONTHLYBALANCE: "Monthly balance",
	WEEKLYBALANCE: "Weekly balance",
	DAYSBALANCE: "Days balance",
	NEWACTIVITY: "New activity",
	LIVECREATIONREQUEST: "live activity creation",
	CREATIONREQUEST: "activity creation",
	CHANGEREQUEST: "activity change",
	DELETEREQUEST: "activity deletion",
	SEALDATERANGEREQUEST: "seal request",
	UNSEALDATERANGEREQUEST: "unseal request",
	SEALACTIVITYREQUEST: "seal request",
	UNSEALACTIVITYREQUEST: "unseal request",
	REQUESTCARD_FROM: "From",
	REQUESTCARD_TO: "To",
	REQUESTCARD_NEW: "New",
	REQUESTCARD_REMOVAL: "Removal",
	PREVIOUSVERSIONNOTAVAILABLE: "Previous version is not available",
	SUPERIOR: "Superior",
	ASSIGNEDACTIVITIES: "Assigned activities",
	THEREQUESTWAS: "The request was",
	NOTYETPROCESSED: "not yet processed",
	ACCEPTED: "accepted",
	DECLINED: "declined",
	ASSIGNEDTO: "Assigned to",
	ACTIVITYHISTORY: "Activity history",
	ONLINECLOCKIN: "Online clock in",
	OFFLINECLOCKIN: "Offline clock in",
	ACTIVITYCLOCKEDIN: "Activity clocked in",
	ACTIVITYCREATED: "Activity created",
	ACTIVITYREWORK: "Activity rework",
	ACTIVITYDELETION: "Acitivty deletion",
	UNKNOWN: "Unknown",
	ACTIVE: "Active",
	ATTENTION: "Attention",
	SEALQUESTION: "Do you really wish to seal this activity?",
	UNSEALQUESTION: "Do you really wish to unseal this activity?",
	DELETEQUESTION: "Do you really wish to delete this activity?",
	DELETECOMPENSATIONQUESTION: "Do you really wish to delete this balance compensation?",
	DELETEASSIGNMENTQUESTION: "Do you really wish to delete this assignment?",
	YES: "Yes",
	NO: "No",
	WORKINGTIMEFRAMEVIEW: "Working time frame view",
	WORKINGTIMEVIEW: "Working time view",
	ACTIVITYTIMELINE: "Activity-Timeline",
	FLEXTIME: "Flexible working time",
	OUTISDEWORKTIME: "Outside working time frame",
	NORMTIME: "Regular working time",
	CORETIME: "Core working time ",
	AUTOMATICPAUSE: "Automatic pause time",
	NOTCALCULATED: "Not calculated",
	NORMALTIME: "Normal working time",
	REDUCEDTIME: "Reduced working time",
	OVERTIME: "Overtime",
	EXTRATIME: "Extra working time",
	NEGATIVE: "negative",
	UNPAID: "unpaid",
	WORKINGTIME: "Workingtime",
	WORKINGTIMES: "Workingtimes",
	LASTONLINE: "Last online",
	NEVER: "Never",
	CONFIRM: "Confirm",
	REJECT: "Reject",
	CONFIRMREQUESTQUESTION: "The request contains several activities. You thus confirm all linked activities.",
	REJECTREQUESTQUESTION: "The request contains several activities. You thus reject all linked activities.",
	FORWARDREQUEST: "Forward request",
	SUPERVISOR: "Supervisor",
	FORWARD: "Forward",
	ASSIGNTO: "To",
	ASSIGNCOMMENT: "Assign comment",
	REQUESTCREATED: "Request created",
	REQUESTREOPENED: "Request reopened",
	REQUESTHISTORY: "Request history",
	REQUESTHISTORY_CREATED: "request was created from {{user}}",
	REQUESTHISTORY_REOPENED: "request was reopened from {{user}}",
	REQUESTHISTORY_FORWARDED: "request was forwarded from {{user}}",
	REQUESTHISTORY_ANSWERED: "request was answered from {{user}}",
	REQUESTHISTORY_ACCEPTED: "request was accepted from {{user}}",
	REQUESTHISTORY_DECLINED: "request was declined from {{user}}",
	REQUESTHISTORY_ANSWER_CHANGED: "answer was changed from {{user}}",
	REQUESTHISTORY_ANSWER_CHANGED_ACCEPTED: "answer was changed to accepted from {{user}}",
	REQUESTHISTORY_ANSWER_CHANGED_DECLINED: "answer was changed to declined from {{user}}",
	REQUESTHISTORY_PURPOSE_CHANGED: "request purpose was changed from {{user}}",
	REQUESTHISTORY_JUSTIFICATION_CHANGED: "justification was changed from {{user}}",
	REQUESTPURPOSE: "Request purpose",
	JUSTIFICATION: "Justification",
	COMMENTTRAIL: "Request history",
	FORWARDCOMMENT: "Forward comment",
	REQUESTPURPOSECHANGED: "Request purpose changed",
	JUSTIFICATIONCHANGED: "Justification changed",
	ANSWERCHANGED: "Answer changed",
	PREVIOUS: "Previous",
	REQUESTSOFME: "Current requests from you",
	REQUESTSTOME: "Recent requests to you",
	REQUESTS: "Requests",
	PREVIOUSREQUESTSOFME: "Previous requests from you",
	PREVIOUSREQUESTSTOME: "Previous requests to you",
	LOADREQUESTHISTORY: "Load request history",
	NOREQUESTSFOUND: "No requests found",
	OFTHELAST: "of the last",
	CURRENTSTATE: "Current state",
	ONLINE: "Online",
	OFFLINE: "Offline",
	AWAY: "Away",
	WORKING: "Working",
	NOTAVAILABLE: "Not available",
	CREATEDAT: "Created at",
	CREATED: "Created",
	ANSWER: "Answer",
	ACCEPT: "Accept",
	DECLINE: "Decline",
	INDIVIUDALMODE: "Individually",
	HOURLYMODE: "Hourly",
	HALFDAYMODE: "Halfday",
	FULLDAYMODE: "Fullday",
	MANUALBALANCECOMPENSATION: "Manual balance compensation",
	SETABSOLUTEBALANCE: "Set absolute balance",
	TARGETBALANCEVALUE: "Target value",
	ABSOLUTEBALANCENOFUTUREINFO: "The current balance used as the basis on that day does not include future planned activities.",
	AMCOMPENSATIONAMOUNTOUNT: "Amount",
	FIRSTHALF: "First half",
	SECONDHALF: "Second half",
	COMPENSATIONTYPE: "Mode",
	COMPENSATIONUNIT: "Unit",
	SECONDS: "Seconds",
	MINUTES: "Minutes",
	HOURS: "Hours",
	DAYS: "Days",
	SHOULDHOURSDIVISION: "Should work division",
	WORKMODEDIVISION: "Workmode division",
	OBJECTDIVISION: "{{object}} division",
	OBJECTDIVISIONPERCENTAGEINFO: "The values are based on all work modes, including any vacations and absences - see workmode division.",
	OBJECTCOMBINATIONDIVISION: "Object assignment combination",
	TOTALUNTIL: "Total until",
	CURRENTAPERIODUNTIL: "Current timetracking balance on",
	CURRENTAPERIOD: "Current timetracking balance",
	SIMULATETERMINATION: "Simulate work termination on this date",
	LASTWEEK: "last Week",
	LASTMONTH: "last Month",
	CALENDARWEEK: "Calendarweek",
	BALANCEDIFFERENCE: "Balance difference",
	VACATIONDIFFERENCE: "Vacation difference",
	EXPANDALL: "Expand all",
	COLLAPSEALL: "Collapse all",
	BEFORE: "Before",
	AFTER: "After",
	TEAMABSENCECALENDAR: "Absence calendar",
	INSERTEDAT: "deposited at",
	DISABLED: "Deaktiviert",
	NOTEMPLOYED: "Not employed",
	NEXTDAY: "next day",
	ASSIGNED: "Assigned",
	CREATENEWOBJECT: "New {{object}}",
	EDITOBJECT: "Edit {{object}}",
	EDIT: "Edit",
	ME: "me",
	OBJECTSNOTAVAILABLE: "Sorry, you haven't assigned any {{objects}} and you're not allowed to create any.",
	THISFIELDISREQUIRED: "This field has to be filled",
	ICON: "Icon",
	COLOR: "Color",
	CANSEEWHOLEDATA: "Can view all data",
	OPEN: "open",
	SEALED: "Sealed",
	PARTIALLYSEALED: "Partially sealed",
	ALREADYSEALED: "already sealed",
	REQUEST: "Request",
	REQUESTWILLBECREATED: "A request will be created for this action.",
	DAYISSEALED: "Day is sealed",
	UNSEALDATERANGEQUESTION: "Do you really wish to unseal the following daterange?",
	SEALDATERANGE: "Seal daterange",
	SEALDATERANGECONFIRM: "Do you really want to seal the date range when exporting this report?",
	DATERANGEALREADYSEALED: "This date range is already sealed. The export will proceed without additional sealing.",
	SEALEDRANGES: "Existing sealed ranges",
	SEAL: "Seal",
	UNSEAL: "Unseal",
	SEALACTIVITY: "Seal activity",
	UNSEALACTIVITY: "Unseal activity",
	SEALACTION: "Action",
	TARGET: "Target",
	COPYACTIVITY: "Copy activity",
	ACTIVITYVIEW: "Activityview",
	ACTIVITYDESCRIPTION: "Activitydescription",
	NODESCRIPTION: "No description",
	WITHOUTOBJECT: "Without object assignment",
	PARTDAYS: "Halfdays",
	ALREADYPLANNED: "Already planned",
	UPDATE: "Update",
	UPDATEACTIVITY: "Update activity",
	PARENTOBJECT: "Parent {{object}}",
	NOPARENTOBJECT: "No parent {{object}}",
	LOCKOBJECT: "Lock {{object}}",
	ARCHIVEOBJECT: "Archive {{object}}",
	SEARCH: "Search",
	NOOBJECTSSFOUND: "No {{objects}} found",
	FINISHED: "Finished",
	ARCHIVED: "Archived",
	STATE: "State",
	STARTSAT: "Starts at",
	ENDEDAT: "Quitted at",
	SHOWBUDGET: "Budget activation",
	INTERNALPRICE: "Internal hourly wage",
	EXTERNALPRICE: "Billable hourly wage",
	BASEEXTERNALPRICE: "Billable base hourly wage",
	HOURLYWAGE: "Hourlywage",
	PLANNEDTOTALBUDGET: "Planned total budget",
	PLANNEDTOTALHOURS: "Planned total hours",
	TOTALBUDGET: "Total budget",
	INVALIDINPUT: "Invalid input",
	SELECTALL: "Select all",
	SELECTNOTHING: "Select nothing",
	SELECTALLACTIVE: "Select all active",
	SELECTALLFINISHED: "Select all finished",
	SELECTNOTHINGACTIVE: "Deselect all active",
	SELECTNOTHINGFINISHED: "Deselect all finished",
	LISTVIEW: "List view",
	CARDVIEW: "Card view",
	ISLOADING: "is loading",
	LOADING: "Loading...",
	LOADINGDETAILS: "Data is being generated. Please wait...",
	LOADINGDATA: "Data is being loaded. Please wait...",
	DETAILS: "Details",
	TOTHEREPORTS: "To the reports",
	TOTHECALENDAR: "To the calendar",
	TOCALENDAR: "To calendar",
	RECALCALL: "Recalculate all balances",
	RECALCALLINFO: "All balances for this user will be recalculated, this may take a minute.",
	PRICE: "Price",
	TOTALHOURS: "Total hours",
	TOTALPRICE: "Total price",
	EMPLOYEES: "Employees",
	EMPLOYEE: "Employee",
	LISTINGPERUSER: "Listing per employee",
	LISTINGPERDAY: "Listing per days",
	TOTALPRICETRANSFERFROMBEFORE: "Price carryover before",
	TOTALHOURSPEREMPLOYEE: "Totalhours per employee",
	TOTALPRICEPEREMPLOYEE: "Totalprice per employee",
	BALANCEDIVISION: "Balance division",
	WITHBUDGET: "with budget",
	SIGNATURECOMPANY: "Signature company",
	SIGNATURECUSTOMER: "Signature customer",
	OBJECTSIGNATUREINFOTEXT: "Company and customer declare that the data recorded reflect the actually worked and that the records have been checked and found to be correct.",
	DETAILEDVIEWFOR: "Detail view for",
	COMBINED: "combined",
	PEREMPLOYEE: "per employee",
	ADMINS: "Admins",
	MINIMUMONE: "Minimum 1",
	QUICKASSIGNMENTS: "Quick assignments",
	DETAILLIST: "Detail listings",
	ASSIGNMENTS: "Assignments",
	COUNTRY: "Country",
	PROVINCE: "Province/Region",
	POSTALCODE: "Postal code",
	CITY: "City",
	STREET: "Street",
	ADDRESSADDITION: "Addressaddition",
	CUSTOMFIELDS: "Custom fields",
	ADDACUSTOMFIELD: "Add a custom field",
	LABEL: "Label",
	VALUE: "Value",
	ADDRESS: "Address",
	MOREINFOS: "More information",
	INHERIT: "Standard",
	DENY: "Deny",
	ALLOW: "Allow",
	FORCE: "Force",
	NOTSET: "Not set",
	NEWASSIGNMENT: "New assignment",
	CALCULATIONMODE: "Calculationmode",
	CALCULATIONMODEREALTIME: "Realtime without supplements or deductions",
	CALCULATIONMODEUSEDTIME: "Usedtime incl. supplements and deductions",
	SHOWONREPORT: "Show in the reports",
	HIERACHYROLE: "Hierarchy role",
	USABLE: "Usable",
	NOTUSABLE: "Not usable anymore",
	OBJECTLINKS: "Object links",
	SELECTIONEXCEEDSMAX: "Selection exceeds the maximum",
	TOTALERRORCOUNTER: "Activityerrors",
	SETTINGS: "Settings",
	INCLUDECOMPENSATIONS: "Include balance compensations",
	HIGHLIGHTED: "Highlighted",
	USEROVERVIEW: "Employee overview",
	DISPLAYTYPE: "Displaymode",
	BUDGETANDPLAN: "Budget & Planning",
	OBJECTMANAGEMENT: "{{object}} management",
	BASEINFORMATION: "Base information",
	MANUALREPORTS: "Manual reports",
	AUTOMATICREPORTS: "Automatic reports",
	REPORTTYPE: "Report type",
	NEXT: "Next",
	GENERATEREPORT: "Generate report",
	OBJECTSELECTION: "{{object}}selection",
	CHOOSEOBJECTITEM: "Choose {{objects}}",
	CHOOSEAREPORTTYPE: "Choose a report type",
	CHOOSEEMPLOYEES: "Choose employees",
	NOEMPLOYEESFOUND: "No employees found",
	ONEPDFFORALLUSER: "Obe PDF file for all employees",
	EXTRAPDFPERUSER: "Separated PDF files per employee",
	COMBINEDEXCELOFUSER: "Merged EXCEL of all employees",
	EXTRAEXCELTABSPERUSER: "Dedicated EXCEL tabs per employee",
	EXTRAEXCELPERUSER: "Separated EXCEL files per employee",
	SHORTSUMMARY: "Short summary",
	ONEPDFFORALLOBJECT: "One PDF file for all {{objects}}",
	EXTRAPDFPEOBJECT: "Separated PDF files per {{object}}",
	COMBINEDEXCELOFOBJECT: "One EXCEL list of all {{objects}}",
	EXTRAEXCELTABSPEROBJECT: "Dedicated EXCEL tabs per {{object}}",
	EXTRAEXCELPEROBJECT: "Separated EXCEL files per {{object}}",
	MULTIPLEOBJECTSLINKED: "Multiple assignments",
	NEW: "New",
	MULTIPLEEMPLOYEES: "Multiple employees",
	MULTIPLEOBJECTS: "Multiple objecs",
	DATEANDTIMEFORMAT: "Date & time format",
	DURATIONANDSUMFORMAT: "Duration & sum format",
	DATEANDTIMECOMBINED: "Date & time combined",
	DATEANDTIMESPLIT: "Date & time split",
	WITHSECONDS: "with seconds",
	FROMDATE: "from date",
	FROMTIME: "from time",
	TODATE: "to date",
	TOTIME: "to time",
	TODAYSHISTORY: "Schedule today",
	NOACTIVITIESFOUND: "No activities found",
	EMPLOYEESSEARCH: "Search employees",
	TASKS: "Tasks",
	MYTASKS: "My Tasks",
	SUBORDINATESTASKS: "Tasks of employees",
	TASKS_VIEW_USER: "By User",
	TASKS_VIEW_OBJECTITEM: "By Object",
	TASKS_NEW: "New Task",
	TASKS_NEW_TASK: "New Task",
	TASKS_FOR_ME: "For me",
	TASKS_ASSIGNED_TO: "Assigned to",
	TASKS_EDIT_TASK: "Edit Task",
	TASKS_NO_TASKS: "No tasks available",
	SEARCH_NO_RESULTS: "No tasks match your search",
	TASKS_OPEN_TASKS: "Your Open Tasks",
	TASKS_NO_OBJECT_ASSIGNMENT: "No Object Assignment",
	TASKS_CLOSED_TASKS: "Closed",
	TASKS_UPCOMING_TASKS: "Upcoming",
	TASKS_DUE: "Due",
	TASKS_DUE_AT: "Due at",
	TASKS_DUE_SINCE: "Due since",
	TASKS_OPEN: "Open from",
	TASKS_OPEN_SINCE: "Open since",
	TASKS_OPEN_INSTANTLY: "Instantly",
	TASK_ACTION_SUCCESS: "Task action completed successfully",
	TASK_DETAILS: "Task Details",
	TASK_NAME: "Task Name",
	TASK_TYPE: "Task Type",
	PRIORITY_VERY_HIGH: "Very High",
	PRIORITY_HIGH: "High",
	PRIORITY_NORMAL: "Normal",
	PRIORITY_LOW: "Low",
	PRIORITY_VERY_LOW: "Very Low",
	TASK_STATUS_OPEN: "Open",
	TASK_STATUS_DONE: "Done",
	TASK_STATUS_FAILED: "Failed",
	TASK_STATUS_ABORTED: "Aborted",
	TASK_STATUS_IGNORED: "Ignored",
	DESCRIPTION: "Description",
	STATUS: "Status",
	PRIORITY: "Priority",
	ASSIGNED_TO: "Assigned To",
	OBJECTITEM: "Object Item",
	OBJECT_ASSIGNMENT: "Object Assignment",
	REVISION: "Revision",
	COMMENT: "Comment",
	COMMENTS: "Comments",
	CREATING_COMMENT: "Creating Comment",
	CLOSING_COMMENT: "Closing Comment",
	CLOSED: "Closed",
	CLOSED_AT: "Closed at",
	HISTORY: "History",
	EDITED: "Edited",
	REOPENED: "Reopened",
	OVERDUE: "Overdue",
	NO_DUE_DATE: "No due date",
	OPEN_DATE_AFTER_DUE_DATE: "Open date cannot be after due date",
	EDIT: "Edit",
	DELETE: "Delete",
	CREATE_TASK: "Create Task",
	EDIT_TASK: "Edit Task",
	CLOSE_TASK: "Close Task",
	REOPEN_TASK: "Reopen Task",
	REASSIGN_TASK: "Reassign Task",
	REASSIGNED: "Reassigned",
	REASSIGNED_TO: "Reassigned to",
	DELETE_TASK: "Delete Task",
	DELETE_TASK_CONFIRM: "Are you sure you want to delete this task?",
	CLOSE_TYPE: "Close Type",
	UPDATE: "Update",
	CREATE: "Create",
	CREATED_BY: "Created By",
	CREATED_AT: "Created At",
	MILESTONES: "Milestones",
	EFFECTIVEMILESTONES: "Effective Milestones",
	PLANNEDMILESTONES: "Planned Milestones",
	DATETIME: "Date & Time",
	NAME: "Name",
	PERCENTAGE: "Percentage",
	PROGRESS: "Progress",
	ACTIONS: "Actions",
	PREVIEW: "Preview",
	PREVIEW_TOOLTIP: "Not yet fully implemented",
	BEHIND_SCHEDULE: "Behind Schedule",
	BEHIND_MILESTONE_SCHEDULE: "This object is behind its planned milestone schedule",
	MILESTONE_PROGRESS: "Milestone Progress",
	MILESTONE_MULTIPLE_SAME_DAY_NOTE: "Note: When multiple milestones are created on the same day, the highest progress is used for that date.",
	PLANNED: "Planned",
	MORE_OPTIONS: "More Options",
	CLOSE: "Close",
	REASSIGN_TASK: "Reassign Task",
	REASSIGNED: "Reassigned",
	REASSIGN_TO: "Reassign To",
	REASSIGN_COMMENT: "Comment (optional)",
	REASSIGNED_TO: "Reassigned to",
	NO_OPTIONS: "No options",
	ADDFAVORITE: "Add to favorites",
	REMOVEFAVORITE: "Remove from favorites",
	FAVORITE: "Favorite",
	REPORTHISTORY: "Report History",
	RUNINBACKGROUND: "Run in Background",
	DELETEALLHISTORY: "Delete all history",
	NOHISTORYREPORTS: "No reports in history",
	HISTORYSAVEDREPORTNOTICE: "This is a previously saved report. The data may differ from the current status.",
	GENERATEDAT: "Generated at",
	REPORT_HISTORY_REMAINING_DAYS: "Available for {{count}} days",
	REPORT_HISTORY_EXPIRES_TODAY: "Expires today",
	REPORTGENERATEDINBACKGROUND: "Report is being generated in the background.",
	FOR: "for",
	REPORT_STATUS_PENDING: "Pending",
	REPORT_STATUS_RUNNING: "Generating",
	REPORT_STATUS_COMPLETED: "Completed",
	REPORT_STATUS_FAILED: "Failed",
	ACTIVITY_TEMPLATES: "Activity Templates",
	ACTIVITY_TEMPLATE: "Activity Template",
	SELECT_TEMPLATE: "Select Template",
	REMOVE_TEMPLATE: "Remove Template",
	NO_TEMPLATES: "No templates available",
	TEMPLATE_NAME: "Template Name",
	TEMPLATE_APPLIED: "Template applied",
	PERSONAL_TEMPLATE: "Personal",
	COMPANYWIDE_TEMPLATE: "Company-wide",
	TEMPLATE_ITEMS_REMOVED: "Some items are no longer assigned and were not applied.",
	EXTERNAL_IMPORT_FROM_EXTERNAL_CALENDAR: "Import from External Calendar",
	PROVIDER_MICROSOFT: "Microsoft 365",
	PROVIDER_GOOGLE: "Google",
	EXTERNAL_NO_EVENTS: "No events found for this selection.",
	EXTERNAL_ALL_DAY: "All day",
	EXTERNAL_PRIVATE_EVENT: "Private",
	SORTBY: "Sort by",
	SORTORDER: "Sort order",
	SORT_BY_DISPLAYNAME: "Display name",
	SORT_BY_FIRSTNAME: "First name",
	SORT_BY_LASTNAME: "Last name",
	SORT_ASCENDING: "Ascending",
	SORT_DESCENDING: "Descending",
	RECURRING: "Recurring",
	RECURRING_TASK: "Recurring Task",
	RECURRING_INTERVAL: "Interval",
	RECURRING_UNTIL: "Repeat",
	END_RECURRING_TASK: "End Recurring Series",
	END_RECURRING_TASK_CONFIRM: "Stop generating future tasks of this recurring series?",
	RECURRING_BADGE: "Recurring",
	RECURRING_REQUIRES_OPEN_DATE: "Set an open date first to enable recurring",
	RECURRING_BASE: "Base",
	RECURRING_BASE_OPEN: "Open from",
	RECURRING_BASE_DUE: "Due date",
	RECURRING_BASE_REQUIRES_DUE: "Set a due date to use due date as the recurring base",
	RECURRING_EVERY: "every",
	RECURRING_ORDINAL_SUFFIX: "",
	RECURRING_UNTIL_DATE_PREFIX: "until",
	RECURRING_NEXT_AFTER_CLOSE_INFO: "The next recurring task is only created after the current task of this series is closed.",
	RECURRING_BASE_INFO: "Controls which date the interval snaps to. 'Base: Open from' means the interval defines the next open date — the due date is then calculated by adding the day difference. 'Base: Due date' means the interval defines the next due date — the open date is calculated by subtracting the day difference.",
	UNIT_DAY: "Days",
	UNIT_WEEK: "Weeks",
	UNIT_MONTH: "Months",
	UNIT_QUARTER: "Quarters",
	UNIT_HALFYEAR: "Half-years",
	UNIT_YEAR: "Years",
	UNIT_TIMES: "Times",
	UNIT_UNTIL_DATE: "Fixed date",
	UNIT_STARTOFWEEK: "First of week",
	UNIT_ENDOFWEEK: "Last of week",
	UNIT_STARTOFMONTH: "First of month",
	UNIT_ENDOFMONTH: "Last of month",
	UNIT_STARTOFQUARTER: "First of quarter",
	UNIT_ENDOFQUARTER: "Last of quarter",
	UNIT_STARTOFHALFYEAR: "First of half-year",
	UNIT_ENDOFHALFYEAR: "Last of half-year",
	UNIT_STARTOFYEAR: "First of year",
	UNIT_ENDOFYEAR: "Last of year",
};

export default locale;
